import { RemittanceFileRecord } from './remittance-file-record';
import { DateUtils } from '../../utils/date-utils';
import { Deserializable } from '../protocols/deserializable';
import { UniquelyIdentifiable } from '../protocols/uniquely-identifiable';

export class ContributionEntry implements Deserializable, UniquelyIdentifiable {
  id!: string;
  contributionId!: string;
  codeId!: number;
  taxationYear!: string;
  amount!: number;

  constructor(record?: RemittanceFileRecord) {
    if (record) {
      this.codeId = Number(record['ENTRY CODE']);
      this.taxationYear = DateUtils.yearToDateOnlyString(record['TAXATION YEAR']);
      this.amount = record.AMOUNT;
    }
  }

  onDeserialize() {}

  getUniqueIdentifier(): string {
    return `${this.id}-
    ${this.contributionId}-
    ${this.codeId}-
    ${this.taxationYear}-
    ${this.amount}`;
  }
}
